import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_DISTRICT,
  GET_PROVINCE,
  GET_WARD,
} from '@stores/common/contants.js';
import {
  getDistrictDataService,
  getProvinceDataService,
  getWardDataService,
} from '@services/common/common.js';

export function* getProvinceData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getProvinceDataService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getDistrictData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getDistrictDataService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getWardData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getWardDataService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export default function* commonSaga() {
  yield takeLatest(GET_PROVINCE, getProvinceData);
  yield takeLatest(GET_DISTRICT, getDistrictData);
  yield takeLatest(GET_WARD, getWardData);
}
